import './style.css';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import { CancelOutlined, PersonOutline } from '@mui/icons-material'; 
import ThirdsModal from '../../organisms/thirdsModal/modal'; 

function ClientInfo({ tercero, extractedThird, notActions = false, hidden = false, type = 'client', variant = 'default', onSelected, skipModal = false }) {
    const isSmall = variant === 'small';

    if (!tercero?.name) {
        return (
            <div hidden={hidden} className={`client-info-wrapper ${isSmall ? 'mini' : ''}`}>
                {!skipModal && <ThirdsModal id='third-select' type={type}></ThirdsModal>}
                <div className='box-tercero-empty'>
                    <button
                        className='box-tercero-empty-button'
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (onSelected) {
                                const unbind = listener("btn-thirds-add", (e) => {
                                    onSelected(e.detail.data);
                                    unbind();
                                });
                            }
                            dispatchCustomEvent('toggle-thids-modal', { type: type, initialThird: extractedThird })
                        }}
                    >
                        <PersonOutline />
                        {!isSmall && <p>{type === 'provider' ? 'Seleccionar Proveedor' : 'Seleccionar Cliente'}</p>}
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div hidden={hidden} className={`client-info-container ${isSmall ? 'mini' : ''}`}>
            <p
                hidden={notActions}
                className='remove-third'
                onClick={() => {
                    if (onSelected) {
                        onSelected(undefined);
                    } else {
                        dispatchCustomEvent("btn-thirds-add", undefined);
                    }
                }}
            ><CancelOutlined></CancelOutlined>
            </p>
            {isSmall ? (
                <div className="mini-details">
                    <PersonOutline className="mini-icon" />
                    <p className="mini-name">{tercero.name}</p>
                </div>
            ) : (
                <>
                    <span>
                        Nombre:
                        <p>{tercero ? tercero.name : "--------"}</p>
                    </span>
                    <span>
                        Documento:
                        <p>{tercero ? tercero.identification : "--------"}</p>
                    </span>
                    <span>
                        Email:
                        <p>{tercero ? tercero.email : "--------"}</p>
                    </span>
                </>
            )}
        </div>
    );
}

export default ClientInfo;
